import {
  ADD_ACCOUNT_TRANSACTION_CLIENT,
  ADD_ACCOUNT_TRANSACTION_CLIENT_SUCCESS,
  ADD_ACCOUNT_TRANSACTION_CLIENT_FAIL,
  ADD_ACCOUNT_TRANSACTION_CLIENT_BANK,
  ADD_ACCOUNT_TRANSACTION_CLIENT_BANK_SUCCESS,
  ADD_ACCOUNT_TRANSACTION_CLIENT_BANK_FAIL,
  ADD_BY_EXCEL_ACCOUNT_TRANSACTION_CLIENT,
  ADD_BY_EXCEL_ACCOUNT_TRANSACTION_CLIENT_SUCCESS,
  ADD_BY_EXCEL_ACCOUNT_TRANSACTION_CLIENT_FAIL
} from "./actionTypes";

const INIT_STATE = {
  error: '',
  loading: false
};

const AccountTransactionClient = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_ACCOUNT_TRANSACTION_CLIENT:
      return {
        ...state,
        loading: true,
      };
    case ADD_ACCOUNT_TRANSACTION_CLIENT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ADD_ACCOUNT_TRANSACTION_CLIENT_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case ADD_ACCOUNT_TRANSACTION_CLIENT_BANK:
      return {
        ...state,
        loading: true,
      };
    case ADD_ACCOUNT_TRANSACTION_CLIENT_BANK_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ADD_ACCOUNT_TRANSACTION_CLIENT_BANK_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    
    case ADD_BY_EXCEL_ACCOUNT_TRANSACTION_CLIENT:
      return {
        ...state,
        loading: true,
      };
    case ADD_BY_EXCEL_ACCOUNT_TRANSACTION_CLIENT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ADD_BY_EXCEL_ACCOUNT_TRANSACTION_CLIENT_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default AccountTransactionClient;
